import SearchIcon from '@mui/icons-material/Search';
import {
  Button,
  Paper,
} from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useContext, useState } from 'react';

import { AttributeDefinitionsContext } from './AttributeDefinitionsContext';
import DefinitionKeyFilter from './components/filter/DefinitionKeyFilter';
import Filter from './components/filter/Filter';

function AttributeDefHeader({
  globalAttrCount, localAttrCount, setOpenCreate, tabIndex,
}) {
  const {
    readOnly, mandatory, defaultValue, includeInSearchKeywords, globalVal, resetAllFilters, fetchData, fetchLogs, includeProductCount, logsFrom, logsTo,
  } = useContext(AttributeDefinitionsContext);
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = () => setShowPopup(!showPopup);
  const filterIncludeProductCount = includeProductCount === false && null;
  const filters = {
    readOnly,
    mandatory,
    defaultValue,
    globalVal,
    includeInSearchKeywords,
    filterIncludeProductCount,
  };

  let selectedCount = Object.values(filters).filter((v) => v !== null).length;

  if (logsFrom !== null || logsTo !== null) {
    selectedCount += 1;
  }

  return (
    <div className="flex flex-col justify-between mb-4 md:mb-8 md:flex-row md:items-center">
      <div>
        <Box sx={{ padding: '20px' }}>
          <Typography
            variant="h3"
            sx={{
              color: '#384451',
              marginBottom: 1,
            }}
          >
            Attributes Definition
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: 3 }}>
            Manage Attributes and Attribute values
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Box
                sx={{
                  marginBottom: 0,
                  width: '800px',
                }}
              >
                <Stack direction="row" gap={2}>
                  <DefinitionKeyFilter tabIndex={tabIndex} />
                  <Button
                    onClick={togglePopup}
                    className="text-main ml-4"
                  >
                    FILTERS
                    {' '}
                    <span className="text-green-700">
                      {selectedCount > 0 ? `+${selectedCount}` : null}
                    </span>
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: 30,
                      width: 130,
                      height: '45px',
                      backgroundColor: '#384451',
                    }}
                    onClick={resetAllFilters}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SearchIcon />}
                    sx={{
                      borderRadius: 30,
                      width: 130,
                      height: '45px',
                      backgroundColor: '#384451',
                    }}
                    onClick={() => {
                      if (tabIndex === 1 || tabIndex === 0) {
                        fetchData();
                      }
                      if (tabIndex === 2) {
                        fetchLogs();
                      }
                    }}
                  >
                    Search
                  </Button>
                </Stack>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
      <Stack direction="column" gap={2} spacing={2}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
          }}
        >
          <Paper
            elevation={1}
            sx={{
              borderRadius: '20px',
              padding: 1,
              textAlign: 'left',
              width: 150,
              border: '2px solid #5A9EA8',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: '#5A9EA8',
                fontWeight: 'bold',
              }}
            >
              Global Attributes
            </Typography>
            <Typography variant="h4">
              <center>{globalAttrCount}</center>
            </Typography>
          </Paper>
          <Paper
            elevation={1}
            sx={{
              borderRadius: '20px',
              padding: 1,
              textAlign: 'left',
              width: 150,
              border: '2px solid #5A9EA8',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: '#5A9EA8',
                fontWeight: 'bold',
              }}
            >
              Local Attributes
            </Typography>
            <Typography variant="h4">
              <center>{localAttrCount}</center>
            </Typography>
          </Paper>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="contained"
            sx={{
              borderRadius: 30,
              width: 160,
              height: '45px',
              backgroundColor: '#384451',
            }}
            onClick={() => setOpenCreate(true)}
          >
            + New Attribute
          </Button>
        </Box>
      </Stack>
      {showPopup && <Filter showPopup={showPopup} setShowPopup={setShowPopup} tabIndex={tabIndex} />}
    </div>
  );
}

export default AttributeDefHeader;
